// extracted by mini-css-extract-plugin
module.exports = {"head":"index_head_1ZHdl","headItem":"index_headItem_TkYBB","headIcon":"index_headIcon_1e1ER","avatar":"index_avatar_3voK1"};